import * as React from 'react';
import * as classNames from 'classnames';

import CoreLink from './core_link';
import { get } from 'lodash';

interface IProps {
  article: any;
  renderForSidebar?: boolean;
  cardStyle?: string;
}

export default class ArticleCollectionCard extends React.Component<IProps, null> {
  getCategoryName(article) {
    return get(article, 'articleCategories[0].name') ||
      get(article, 'categories[0].name');
  }

  getURL(article) {
    return get(article, 'webLink.href') ||
      get(article, '_links.web.href');
  }

  getImageURL(article) {
    return get(article, 'images[0].source') ||
      get(article, 'photo');
  }

  getBackgroundImageStyle(article) {
    const src = this.getImageURL(article);
    if (!src) return null;

    return {
      backgroundImage: `url(${src})`,
      // this should be in image-box by default but isn't yet
      backgroundSize: 'cover',
    };
  }

  renderSidebarPlaceholder() {
    return (
      <div
        className="article-collection-sidebar card article-collection-sidebar-card--placeholder"
      >
        <div className="image-box bg-offwhite" />
        <div className="pl-1">
          <h4 className="size-90" />
        </div>
      </div>
    );
  }

  renderPlaceholder() {
    if (this.props.renderForSidebar) return this.renderSidebarPlaceholder();

    return (
      <div
        className="article-collection-card article-collection-card--placeholder"
      >
        <div className="article-collection-card__primary">
          <div
            className="article-collection-card__img"
          />
          <h4 className="article-collection-card__title" />
        </div>
      </div>
    );
  }

  renderForSidebar() {
    const { article } = this.props;

    return (
      <CoreLink
        className="article-collection-sidebar-card"
        to={this.getURL(article)}
        entityId={article.id}
      >
        <div className="fx-width-25 mobile-fx-width-20">
          <div
            className="image-box"
            style={this.getBackgroundImageStyle(article)}
          />
        </div>
        <div className="pl-1">
          <h4 className="size-90">
            {article.title}
          </h4>
        </div>
      </CoreLink>
    );
  }

  render() {
    const { article } = this.props;
    if (!article) return this.renderPlaceholder();
    if (this.props.renderForSidebar) return this.renderForSidebar();
    const classes = classNames(
      'article-collection-card',
      { 'article-collection-card--large': this.props.cardStyle === 'large' },
    );

    return (
      <CoreLink
        className={classes}
        to={this.getURL(article)}
        entityId={article.id}
      >
        <div className="article-collection-card__primary">
          <div
            className="article-collection-card__img"
            style={this.getBackgroundImageStyle(article)}
          />
          <h4 className="article-collection-card__title">
            {article.title}
          </h4>
        </div>
        <div className="article-collection-card__meta">
          <div className="article-collection-card__category">
            {this.getCategoryName(article)}
          </div>
        </div>
      </CoreLink>

    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/article_collection_card.tsx